// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".share-link-logo--j9BMb{position:absolute;top:10px;right:10px;z-index:199;display:flex;filter:drop-shadow(0 1px 4px rgba(0, 0, 0, 0.6))}.share-link-logo--j9BMb img{display:block;height:24px;width:auto}.share-link-logo--j9BMb:hover{opacity:.8}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"share-link-logo": "share-link-logo--j9BMb"
};
export default ___CSS_LOADER_EXPORT___;
